import React from 'react';

/**
 * AdserverLeaderboard Component
 * Displays a horizontal leaderboard ad using an iframe with a fallback link and image.
 */
const AdserverLeaderboard = () => {
    return (
        <div className="banner2 border-radious5 banner_horizontal mb20 mt20">
            <iframe
                title="adserver-horizontal"
                id="af7ff64e"
                name="af7ff64e"
                src="https://cm2.regiohealth.net/cma/www/delivery/afr.php?zoneid=3&amp;cb=INSERT_RANDOM_NUMBER_HERE"
                frameBorder="0"
                scrolling="no"
                width="892"
                height="110"
                allow="autoplay"
            >
                {/* Fallback content for browsers that block iframes */}
                <a
                    href="https://cm2.regiohealth.net/cma/www/delivery/ck.php?n=a08b75b4&amp;cb=INSERT_RANDOM_NUMBER_HERE"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img
                        src="https://cm2.regiohealth.net/cma/www/delivery/avw.php?zoneid=3&amp;cb=INSERT_RANDOM_NUMBER_HERE&amp;n=a08b75b4"
                        border="0"
                        alt="Ad"
                    />
                </a>
            </iframe>
        </div>
    );
};

export default AdserverLeaderboard;
